// extracted by mini-css-extract-plugin
export default {"assets-by-screen-size--mobile":"d4-rvU+wwJY3N2kCLpkWmQ==","assets-by-screen-size--desktop":"_5SwEzoUBUrUTB1NoCPpQYQ=="};